import React from 'react';
import CustomAddButton from '../../../../Components/custom_components/CustomAddButton/CustomAddButton';
import '../../LookupsCommonStyles/LookupsTopContainerStyle.css'
import CustomBreadcrumbs from '../../../../Components/custom_components/CustomBreadcrumbs/CustomBreadcrumbs';

function CertificationSearchFilter({ isAddPermission, tableTitle, isAddEdiModalOpen, handleAddEditModal }) {

    const handlemodal = () => {
        handleAddEditModal(!isAddEdiModalOpen);
    }
    const breadcrumbs =['Settings', tableTitle]
    return (
        <div className='lookup-filter-container'>
            <div className='lookup-filter-sub-container'>
                <div className='lookup-title-nav-section'>
                    <div className="lookup-section-title">{tableTitle}</div>
                    <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div></div>
                    <div className='lookup-action-button-container'>
                        {isAddPermission && <CustomAddButton label={`Add`} onClick={handlemodal} />}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CertificationSearchFilter;
